import {
  // currentIp as fetchCurrentIp,
  // camelize,
  // CurrentIp,
  AuthContext,
  pushStag,
} from '@repo-level/core-front';
import { AnalyticsEventName } from 'api/analytics';
import { sendEventToAnalyticsFn } from 'helpers/analytics';
import { CROSS_SALE_STAGS, STAG_PARAMS } from 'helpers/conf';
import { NDB_STAGS } from 'helpers/constants';
import { LocalStorage } from 'helpers/localStorage';
import { useContext, useEffect, useMemo, useState } from 'react';
import { getCleanUrl, getParamsToState } from '../helpers';

export const localStorageIsStag = new LocalStorage<boolean, boolean>(
  'isStag',
  false
);
export const localStorageStag = new LocalStorage<string, null>('stag', null);

export const localStorageSpecialStag = new LocalStorage<string, null>(
  'specialStag',
  null
);

const getStag = (str?: string) => {
  if (str == null) return;
  return str.match(/^\d+/)?.[0];
};

type QueryString = Partial<{ [x: string]: string | undefined }>;

const setSpecialStags = (queryString: QueryString) => {
  const specialStag = CROSS_SALE_STAGS.find(
    (stag) => stag === getStag(queryString.stag)
  );
  if (specialStag == null) return;
  localStorageSpecialStag.push(specialStag);
};

const checkStag = (queryString: QueryString) => {
  if (queryString.stag) {
    localStorageIsStag.push(true);
    localStorageStag.push(queryString.stag);
  }
};

const checkIsStagNDB = (stag: string) =>
  NDB_STAGS.some((stagNDB) => stagNDB === getStag(stag));

const pushStagToServer = async (queryString: QueryString) => {
  if (Object.keys(queryString).length === 0) return;
  await pushStag(queryString);
};

const setVisitToAnalytics = async (queryString: QueryString) => {
  if (queryString.stag == null) return;

  const referrer = (() => {
    try {
      if (queryString.referrer == null) return;
      return atob(queryString.referrer);
    } catch {
      return;
    }
  })();

  const stag = getStag(queryString.stag);

  sendEventToAnalyticsFn({
    name: AnalyticsEventName.VISIT,
    attributes: { stag, url: referrer },
  });
};

export const useTrackingUserParams = () => {
  const { user, pendingUser } = useContext(AuthContext);
  const params = useMemo(() => new URLSearchParams(window.location.search), []);

  const [isStag, setIsStag] = useState(false);
  const [isStagNDB, setIsStagNDB] = useState(false);

  useEffect(() => {
    const localStorageIsStag = localStorage.getItem('isStag');
    const stag = localStorageStag.get();

    if (localStorageIsStag != null && localStorageIsStag === 'true') {
      setIsStag(true);
    }

    if (stag) {
      checkIsStagNDB(stag) && setIsStagNDB(true);
    }
  }, []);

  useEffect(() => {
    if (user?.id != null || pendingUser) return;

    const stag = async () => {
      try {
        // const { data: currentIp } = await fetchCurrentIp()
        //   .then(({ data }) => ({ data: JSON.parse(data) }))
        //   .then(({ data }) => ({ data: camelize(data) as CurrentIp }));
        // checkDomainByLocalization(currentIp);
      } catch (error) {}

      const queryString = getParamsToState(params, STAG_PARAMS);

      if (queryString.stag != null) {
        setIsStag(true);

        checkIsStagNDB(queryString.stag) && setIsStagNDB(true);
      }

      setSpecialStags(queryString);

      checkStag(queryString);

      try {
        await setVisitToAnalytics(queryString);
      } catch (error) {}

      try {
        await pushStagToServer(queryString);

        const cleanUrl = getCleanUrl(params);
        window.history.replaceState(null, '', cleanUrl);
      } catch (error) {}
    };

    stag();
  }, [user?.id, pendingUser, params]);

  return { isStag, isStagNDB };
};
